import axios from 'axios'
import { BILLS_ENDPOINT } from '../../endpoints'

export async function reEnteredVehicle(id) {
  const response = await axios.get(`${BILLS_ENDPOINT}/hasReEnteredVehicle/${id.data}`)
  return response?.data?.data
}
